import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0cb48db9"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-lg font-semibold mr-3" }, "Filter", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!

  return (_openBlock(), _createBlock(_component_ion_card, { class: "filter-card" }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_card_content, null, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "flex justify-end cursor-pointer",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.toggleCollapse && $setup.toggleCollapse(...args)))
          }, [
            _hoisted_1,
            _createVNode(_component_ion_icon, {
              icon: !$setup.collapsed ? $setup.icons.chevronDownOutline : $setup.icons.chevronUpOutline,
              class: "text-primary"
            }, null, 8, ["icon"])
          ]),
          _withDirectives(_createElementVNode("div", null, [
            _createVNode(_component_ion_grid, { class: "ion-no-padding ion-no-margin mt-1.5" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_row, { class: "ion-align-items-center ion-no-padding ion-no-margin" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_col, {
                      size: "12",
                      "size-md": "6"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, { position: "stacked" }, {
                              default: _withCtx(() => [
                                _createTextVNode("Datum von")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_input, {
                              modelValue: $setup.dateFrom,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.dateFrom) = $event)),
                              type: "date",
                              onInput: $setup.handleInput
                            }, null, 8, ["modelValue", "onInput"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_col, {
                      size: "12",
                      "size-md": "6"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, { position: "stacked" }, {
                              default: _withCtx(() => [
                                _createTextVNode("Datum bis")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_input, {
                              modelValue: $setup.dateTo,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.dateTo) = $event)),
                              type: "date",
                              onInput: $setup.handleInput
                            }, null, 8, ["modelValue", "onInput"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_col, {
                      size: "6",
                      "size-md": "6"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, { position: "stacked" }, {
                              default: _withCtx(() => [
                                _createTextVNode("Transaktions Typ")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_select, {
                              modelValue: $setup.selectedType,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.selectedType) = $event)),
                              onIonChange: $setup.handleSelectChange
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_select_option, { value: "" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Typ auswählen")
                                  ]),
                                  _: 1
                                }),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.types, (type) => {
                                  return (_openBlock(), _createBlock(_component_ion_select_option, {
                                    key: type,
                                    value: type
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(type), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "onIonChange"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_col, {
                      size: "6",
                      "size-md": "6"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, { position: "stacked" }, {
                              default: _withCtx(() => [
                                _createTextVNode("Transaktions Sub-Typ")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_select, {
                              modelValue: $setup.selectedSubtype,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.selectedSubtype) = $event)),
                              onIonChange: $setup.handleSelectChange
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_select_option, { value: "" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Sub-Typ auswählen")
                                  ]),
                                  _: 1
                                }),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.subTypes, (subtype) => {
                                  return (_openBlock(), _createBlock(_component_ion_select_option, {
                                    key: subtype,
                                    value: subtype
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(subtype), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "onIonChange"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_col, {
                      size: "8",
                      "size-md": "10",
                      class: "mt-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_button, {
                          expand: "block",
                          color: "success",
                          fill: "outline",
                          onClick: $setup.handleSubmit
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_icon, {
                              slot: "start",
                              icon: $setup.icons.filter
                            }, null, 8, ["icon"]),
                            _createTextVNode(" Filtern ")
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_col, {
                      size: "4",
                      "size-md": "2",
                      class: "mt-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_button, {
                          expand: "block",
                          fill: "outline",
                          color: "danger",
                          onClick: $setup.handleReset
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_icon, {
                              icon: $setup.icons.trash
                            }, null, 8, ["icon"])
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ], 512), [
            [_vShow, $setup.collapsed]
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}